import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Component, OnInit, Input, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { AnnouncementModel } from '@fgb/core';
import { DateTime } from 'luxon';
import { Subject, takeUntil } from 'rxjs';
interface AnnouncementModelExtend extends AnnouncementModel {
  LinkTitle: string;
}
@Component({
  selector: 'fgb-announcement-content',
  templateUrl: './announcement-content.component.html',
  styleUrls: ['./announcement-content.component.scss'],
})
export class AnnouncementContentComponent implements OnInit {
  @Input() announcement: AnnouncementModelExtend;
  isDisabled: boolean;
  @ViewChild('link') private _link: ElementRef<HTMLAnchorElement>;
  isComingSoon: boolean = false;
  isEnableTarget: boolean = false;
  private _destroyed$ = new Subject<void>();

  constructor(
    private renderer: Renderer2,
    private breakpointObserver: BreakpointObserver
  ) {}

  ngOnInit() {
    this.isDisabled = !!!this.announcement.LinkUrl;
    const comingSoonDate = DateTime.fromISO(this.announcement.ComingSoonDate as string, { zone: 'utc' });
    const requestTime = DateTime.fromISO(this.announcement.RequestTime as string, { zone: 'utc' });
    const itemStartDate = DateTime.fromISO(this.announcement.StartDate as string, { zone: 'utc' });

    this.isComingSoon = this.announcement.AllowComingSoon && (itemStartDate > requestTime || comingSoonDate > requestTime);

    // detect screen size changes
    this.breakpointObserver
      .observe(['(max-width: 991px)'])
      .pipe(takeUntil(this._destroyed$))
      .subscribe((result: BreakpointState) => {
        if (result.matches) {
          this.isEnableTarget = false;
        } else {
          this.isEnableTarget = true;
        }
      });
  }

  checkIsInternalLink() {
    if (this.announcement?.LinkUrl) {
      return this.announcement?.LinkUrl.startsWith('/') && !/^https?:\/\//.test(this.announcement?.LinkUrl);
    }
    return false;
  }

  ngAfterViewInit(): void {
    this.checkLink();
  }

  checkLink(): void {
    if (this.isDisabled) {
      if (this._link) {
        this.renderer.addClass(this._link.nativeElement, 'disabled');
        this.renderer.setAttribute(this._link.nativeElement, 'aria-disabled', 'true');
        this.renderer.listen(this._link.nativeElement, 'click', (event) => {
          // While user click is disabled, keyboard event still able to click using enter key
          // Prevents entering using keyboard
          event.preventDefault();
        });
      }
      return;
    }
  }

  ngOnDestroy() {
    this._destroyed$.next();
    this._destroyed$.complete();
  }
}
